import React from "react";
import styles from "./styles.scss";

const FlexPanel = ({ children }: { children: any }) => {
  return (
    <div className="flex-panel-wrapper">
      <div className="flex-panel">{children}</div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default FlexPanel;
